import { render, staticRenderFns } from "./TravelForm.vue?vue&type=template&id=dca97238"
import script from "./TravelForm.vue?vue&type=script&lang=js"
export * from "./TravelForm.vue?vue&type=script&lang=js"
import style0 from "./TravelForm.vue?vue&type=style&index=0&id=dca97238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports